import React, { Component } from 'react'
import axios from 'axios'
import img from '../helpers/img'
import endpoint from '../helpers/endpoint'
import '../styles/Tweet.scss'

class Tweet extends Component {
  constructor() {
    super()

    this.state = {
      tweet: ''
    }
  }

  async componentDidMount() {
    try {
      const res = await axios.get(endpoint('tweet'))
      if (!res || !res.data) return
      this.setState({
        tweet: res.data.latest
      })
    }
    catch(e) {
      console.error(e)
    }
  }

  render() {
    const backgroundImage = `url(${img('svg/twitter.svg')})`
    const style = { backgroundImage }
    return (
      <div className="Tweet" onClick={() => { window.open('http://www.twitter.com/_zak_fisher', '_blank') }}>
        <div className="icon" style={style} />
        <div className="bg" />
        <p>Latest <span>{this.state.tweet}</span></p>
      </div>
    )
  }
}

export default Tweet



// WEBPACK FOOTER //
// ./src/components/Tweet.js